import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";

/**
 * `exportCommand` is the command used to export the archive structure.
 * `exportCommand` is valid if and only if the current user is backoffice user
 */
export default class ExportCommand extends AbstractEntryCommand {
	accept(aVisitor) {
		return aVisitor.visitExportCommand(this);
	}

	requireRefresh() {
		return false;
	}

	priority() {
		return 100;
	}

	heading() {
		return getNamedCommandHeading("Administrative");
	}

	_performOnService() {
		this._documentService.executeExportCommand(this);
	}

	_execute() {
		this._documentService.export();
	}

	static isApplicable(context) {
		return this.shouldShowAdminCommands(context);
	}
}
